import React from 'react';
import Navbar from '../Navbar';
import styles from './layout.module.scss';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.layout}>
    <Navbar />
    {children}
  </div>
);

export default Layout;
